import { Text } from "@flat-ui";
import { Box } from "@mui/material";
import { sectionPlaceholderStyles } from "@components/analytics/in-house/in-house-analytics-styles";

/** Placeholder for the category navigation component (ST-4142) */
export function AnalyticsCategoryNavigation(): JSX.Element {
  return (
    <Box
      data-testid="analytics-category-navigation"
      sx={{
        ...sectionPlaceholderStyles,
        height: "5rem",
      }}
    >
      <Text variant="bodyM">Category Navigation</Text>
    </Box>
  );
}
